import Layout from "@/components/v2/organisms/landing/layout/Layout";
import SEOHead from "@/components/SEOHead";
import AboutHeader from "@/components/v2/molecules/landing/about/AboutHeader";
import AboutMission from "@/components/v2/molecules/landing/about/AboutMission";
import AboutPropertyOwners from "@/components/v2/molecules/landing/about/AboutPropertyOwners";
import AboutValues from "@/components/v2/molecules/landing/about/AboutValues";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAmplitudeEvents } from "@/utils/amplitudeEvents";

const About = () => {
  const { t } = useLanguage();
  const { trackPropertyOwnerMoreInfo } = useAmplitudeEvents();

  const handleWhatsAppClick = () => {
    trackPropertyOwnerMoreInfo();

    const whatsappUrl =
      "https://api.whatsapp.com/send?phone=+523335781778&text=Hola!+Me+interesa+el+servicio+de+gesti%C3%B3n+de+propiedades.&utm_source=General";
    window.open(whatsappUrl, "_blank");
  };

  return (
    <Layout>
      <SEOHead
        title="Estancia Corta | Nosotros"
        description="¡Un buen alojamiento es el inicio de un gran viaje! Ofrecemos a nuestros huéspedes los mejores alojamientos en Manzanillo de super anfitriones en Airbnb."
        canonicalUrl="https://estanciacorta.com/nosotros"
      />
      <AboutHeader translate={t} />
      <AboutMission translate={t} />
      <AboutValues translate={t} />
      <AboutPropertyOwners
        translate={t}
        handleWhatsAppClick={handleWhatsAppClick}
      />
    </Layout>
  );
};

export default About;
